<template>
  <div id="app">
    <div class="cursor-dot"></div>
    <div class="wrapper">
      <div
        class="texture"
        style="
          width: 100%;
          height: 100%;
          background-size: 109px;
          z-index: -999;
          background-repeat: repeat;
          background-image: url('/img/noise.gif');
          opacity: 0.06;
          border-radius: 0;
        "
      ></div>
      <PageHeader />

      <router-view />
      <PageFooter />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    const cursor = document.querySelector(".cursor-dot");
    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;

    const updateCursorProximity = (e) => {
      // Include router-links along with regular links and buttons
      const links = document.querySelectorAll(
        "a, button, .router-link-active, .router-link-exact-active, router-link, [role='link']"
      );
      let closestDistance = Infinity;

      // Check distance to all interactive elements
      links.forEach((link) => {
        const rect = link.getBoundingClientRect();
        const linkCenterX = rect.left + rect.width / 2;
        const linkCenterY = rect.top + rect.height / 2;

        // Calculate distance from cursor to link center
        const distance = Math.hypot(
          e.clientX - linkCenterX,
          e.clientY - linkCenterY
        );

        if (distance < closestDistance) {
          closestDistance = distance;
        }
      });

      // Calculate size based on proximity
      const maxDistance = 200; // Increased detection range
      const minSize = 12; // Default size
      const maxSize = 12; // Maximum size near links

      let size;
      if (closestDistance > maxDistance) {
        size = minSize; // Default size when far from links
      } else {
        // Calculate size - closer means bigger
        const sizeRange = maxSize - minSize;
        const distanceRatio = 1 - closestDistance / maxDistance;
        size = minSize + sizeRange * distanceRatio;
      }

      // Apply the size with smooth transition
      cursor.style.width = `${size}px`;
      cursor.style.height = `${size}px`;
    };

    document.addEventListener("mousemove", (e) => {
      mouseX = e.clientX - 16;
      mouseY = e.clientY - 16;

      // Update cursor position and check proximity
      updateCursorProximity(e);

      // Check what element we're hovering over and its parents
      let hoveredElement = document.elementFromPoint(e.clientX, e.clientY);

      // Reset cursor styles
      cursor.classList.remove("hover-link", "hover-text");

      // Check the element and its parents for interactive elements
      while (hoveredElement && hoveredElement !== document.body) {
        if (
          hoveredElement.tagName.toLowerCase() === "a" ||
          hoveredElement.tagName.toLowerCase() === "button" ||
          hoveredElement.tagName.toLowerCase() === "router-link" ||
          hoveredElement.classList.contains("router-link-active") ||
          hoveredElement.classList.contains("router-link-exact-active") ||
          hoveredElement.closest("router-link") ||
          hoveredElement.closest("a") ||
          hoveredElement.closest("button") ||
          hoveredElement.getAttribute("role") === "link"
        ) {
          cursor.classList.add("hover-link");
          break;
        } else if (
          ["p", "h1", "h2", "h3", "h4", "h5", "h6"].includes(
            hoveredElement.tagName.toLowerCase()
          ) &&
          hoveredElement.textContent.trim() !== ""
        ) {
          cursor.classList.add("hover-text");
          break;
        }
        hoveredElement = hoveredElement.parentElement;
      }
    });

    function animate() {
      const dx = mouseX - currentX;
      const dy = mouseY - currentY;

      currentX += dx * 0.2;
      currentY += dy * 0.2;

      cursor.style.transform = `translate(${currentX}px, ${currentY}px)`;
      requestAnimationFrame(animate);
    }

    animate();
  },
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";

.cursor-dot {
  pointer-events: none;
  position: fixed;
  width: 32px;
  height: 32px;
  background-color: #1966d2;
  border-radius: 50%;
  opacity: 0.8;
  transform: translate(-50%, -50%);
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 9999;

  // Link/button hover state
  &.hover-link {
    background-color: #1966d2;
    opacity: 0.5;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(1.25);
    width: 40px !important;
    height: 40px !important;
    transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }

  // Text hover state
  &.hover-text {
    background-color: #1966d2;
    width: 2px !important;
    height: 32px !important;
    opacity: 1;
    border-radius: 0;
    transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }
}

.mouse-follower {
  pointer-events: none;
  position: fixed;
  width: 150px;
  height: 150px;
  background: linear-gradient(to right, #833ab4, #fd1d1d, #fcb045);
  border-radius: 50%;
  animation: gradient-shift 5s ease infinite;
  transform: translate(-50%, -50%);
  transition: transform 0.1s ease;
  z-index: -2;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  filter: blur(100px);
  opacity: 0.7;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
